import React from 'react';
import { motion } from 'framer-motion';
export function SpaceSection() {
  return <section className="w-full py-24 px-4 md:px-8" data-id="element-139">
      <div className="max-w-7xl mx-auto relative rounded-[2.5rem] overflow-hidden h-[80vh] min-h-[600px] flex items-center" data-id="element-140">
        {/* Background Image */}
        <motion.div initial={{
        scale: 1.1
      }} whileInView={{
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} className="absolute inset-0 z-0" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/hBZ4JaqNrjEA499ecs3LhV/imagen_3.jpg" alt="The Gloss & Chrome Lab Interior" className="w-full h-full object-cover" data-id="element-142" />
          <div className="absolute inset-0 bg-black/20" data-id="element-143" />
        </motion.div>

        {/* Glass Content Panel */}
        <div className="relative z-10 w-full px-6 md:px-16 flex justify-start" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="glass-panel-dark max-w-lg rounded-[2rem] p-8 md:p-12 text-white" data-id="element-145">
            <h2 className="font-syncopate font-bold text-3xl md:text-5xl mb-6 tracking-wider" data-id="element-146">
              THE SPACE
            </h2>
            <p className="font-light text-white/90 leading-relaxed text-lg mb-8" data-id="element-147">
              Designed to transport you. Our lab features custom ergonomic
              seating, ambient neon lighting, and an atmosphere that feels more
              like a high-end gallery than a salon.
            </p>
            <button className="border border-white/50 hover:bg-white hover:text-black transition-colors duration-300 px-8 py-3 rounded-full font-syncopate text-xs tracking-widest uppercase" data-id="element-148">
              Take a Tour
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}